module.exports = __webpack_public_path__ + "img/wind.60c20cde.svg";